'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = window.app;
const googleAnalytics = window.ga;
class AppWrapper extends _react.Component {
  constructor(props) {
    super(props);
    app.router_history = props.history;
  }
  UNSAFE_componentWillUpdate(prevProps) {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
      if (googleAnalytics instanceof Function) {
        googleAnalytics('set', 'page', props.location.pathname);
        googleAnalytics('send', 'pageview');
      }
    }
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, " ", props.routes, " ");
  }
}
var _default = exports.default = (0, _reactRouterDom.withRouter)(props => /*#__PURE__*/_react.default.createElement(AppWrapper, props));
